import React, { useEffect, useState } from 'react'
import {
  ControlProps,
  RankedTester,
  rankWith,
  isStringControl,
  and,
  schemaMatches
} from '@jsonforms/core'

import { useJsonForms, withJsonFormsControlProps } from '@jsonforms/react'
import { withHandleChangeEmitter } from '../WithCustomHandlerHOC'

export const Zip: React.FC<ControlProps> = (props: ControlProps) => {
  const {
    label,
    handleChange,
    data,
    path,
    id,
    errors,
    schema,
    required,
    visible,
    enabled
  } = props

  const [showError, setShowError] = useState<boolean>(false)
  const { core } = useJsonForms()

  const [controlClass, setControlClass] = useState('form-control')

  useEffect(() => {
    ;(required && !data && core?.validationMode === 'ValidateAndShow') ||
    (errors?.length && core?.validationMode === 'ValidateAndShow')
      ? setControlClass('form-control is-invalid')
      : setControlClass('form-control')
  }, [errors, data, core?.validationMode])

  const validate = () => {
    required && !data && core?.validationMode !== 'NoValidation'
      ? setShowError(true)
      : setShowError(false)
  }

  useEffect(() => {
    if (core?.validationMode !== 'ValidateAndShow') {
      setShowError(false)
      return
    }
    if (core?.validationMode === 'ValidateAndShow' && !data) {
      validate()
    }
  }, [core?.validationMode])

  return (
    <>
      {visible && (
        <div className='form-group'>
          <label htmlFor={id} className='custom-input-label'>
            {label}
          </label>
          <input
            type='text'
            value={data ?? ''}
            className={controlClass}
            id={id}
            maxLength={5}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onKeyDown={(ev: any) => {
              const key = ev.keyCode ? ev.keyCode : ev.charCode
              const value = ev.target.value
              if (
                key > 57 &&
                ((key == 190 && value.indexOf('.') >= 0) || key != 190)
              ) {
                ev.preventDefault()
              }
            }}
            onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
              const string = ev.target.value
              handleChange(path, string)
            }}
            onBlur={() => {
              validate()
            }}
            disabled={!enabled}
            data-testid='zip-input'
          />

          {(!!errors || showError) && (
            <div className='text-danger'>
              <span>{`${schema.title} is required`}</span>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export const zipControlTester: RankedTester = rankWith(
  3,
  and(
    isStringControl,
    schemaMatches(
      // eslint-disable-next-line
      (schema: { hasOwnProperty: (arg0: string) => any }) =>
        // eslint-disable-next-line no-prototype-builtins
        schema.hasOwnProperty('isZip')
    )
  )
)

export const ZipControl = withJsonFormsControlProps(
  withHandleChangeEmitter(Zip)
)
